import { PhoneClockIcon } from './PhoneClockIcon';

/**
 * author: Simran
 * id 1B8EA976-32FD-4A71-94FA-EF40FC346FBD
 * name phone-clock
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-clock.svg
 * tags
 * - Cellphone / Phone 
 * - Date / Time 
 */
export const PhoneScheduleIcon = PhoneClockIcon;
export default PhoneScheduleIcon